import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useAuth } from 'contexts/AuthContext';

export default function TenantSwitcher() {
  const { t } = useTranslation();
  const { user, switchTenant } = useAuth();
  const [busy, setBusy] = useState(false);

  const tenants = user?.accessibleTenants;
  if (!user?.canSwitchTenants || !Array.isArray(tenants) || tenants.length < 2) return null;

  const onChange = async (event) => {
    const nextId = event.target.value;
    if (!nextId || nextId === user.tenantId) return;
    setBusy(true);
    try {
      await switchTenant(nextId);
    } finally {
      setBusy(false);
    }
  };

  return (
    <FormControl size="small" sx={{ minWidth: 180, mr: 1 }} disabled={busy}>
      <Select value={user.tenantId} onChange={onChange} aria-label={t('tenants.switcherLabel')} sx={{ maxWidth: 240 }}>
        {tenants.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.isHome ? t('tenants.headquartersName', { name: item.name }) : item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
